import { render, staticRenderFns } from "./ReportTab.vue?vue&type=template&id=79390aa0&scoped=true"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79390aa0",
  null
  
)

export default component.exports